
import QField from "quasar/src/components/field/QField";

export default {
    name: "QfField",
    mixins: [QField],
    props: {
        required: Boolean,
        readonly: Boolean
    },
    computed: {
        classes() {
            return {
                "q-field-responsive": !this.isVertical && !this.isHorizontal,
                "q-field-vertical": this.isVertical,
                "q-field-horizontal": this.isHorizontal,
                "q-field-floating": this.childHasLabel,
                "q-field-no-label": !this.label && !this.$slots.label,
                "q-field-with-error": this.hasError,
                "q-field-with-warning": this.hasWarning,
                "q-field-dark": this.isDark,
                "q-field-no-input": this.hasNoInput,
                "q-field-readonly": this.readonly
            };
        }
    },
    methods: {
        __hasBottom() {
            return this.$slots["error-label"] || this.errorLabel
                    || this.$slots["warning-label"] || this.warningLabel
                    || this.$slots.helper || this.helper
                    || this.count || this.required;
        }
    },
    render(h) {
        const label = this.$slots.label || this.label;

        return h("div", {
            staticClass: "q-field qf-field row no-wrap items-start",
            class: this.classes
        }, [
            this.icon
                ? h("q-icon", {
                    props: this.iconProps,
                    staticClass: "q-field-icon q-field-margin"
                })
                : (this.insetIcon ? h("div", { staticClass: "q-field-icon" }) : null),

            h("div", { staticClass: "row col" }, [
                label || this.insetHasLabel
                    ? h("div", {
                        staticClass: "q-field-label q-field-margin",
                        class: this.labelClasses
                    }, [
                        h("div", { staticClass: "q-field-label-inner row items-center" }, [
                            this.$slots.label || this.label
                        ])
                    ])
                    : null,

                h("div", {
                    staticClass: "q-field-content",
                    class: this.inputClasses
                }, [
                    this.$slots.default,
                    this.__hasBottom()
                        ? h("div", {
                            staticClass: "q-field-bottom row no-wrap"
                        }, [
                            this.required
                                ? h("div", { staticClass: "q-field-required col-auto q-mr-xs" }, ["(Required)"])
                                : null,
                            this.__getBottomContent(h),
                            this.counter
                                ? h("div", { staticClass: "q-field-counter col-auto" }, [this.counter])
                                : null
                        ])
                        : null
                ])
            ])
        ]);
    }
};
